import { useGetSellerDetails } from '@/hooks/sellers/useGetSellerDetails';
import { useToggleSellerStatus } from '@/hooks/sellers/useUpdateSellerStatus';
import { sellerDetailsResponseToSellerProfileUi } from '@/hooks/sellers/useUpdateSellerStatus/mapper';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { SellerProfileUi, initialState } from './SellerProfileUi';

export function useSellerProfileViewController() {
  const { sellerId } = useParams();
  const [uiState, setUiState] = useImmer<SellerProfileUi>(initialState);
  const getSellerDetailsHook = useGetSellerDetails(sellerId);
  const toggleSellerStatus = useToggleSellerStatus();

  useEffect(() => {
    const detailsData = getSellerDetailsHook.data;
    if (!detailsData) return;
    setUiState(sellerDetailsResponseToSellerProfileUi(detailsData));
  }, [getSellerDetailsHook.data]);

  const onMoreOptionSelected = () => {
    if (!sellerId || uiState.isActive === undefined) return;
    toggleSellerStatus.mutate({
      sellerId,
      currentlyActive: uiState.isActive,
    });
  };

  return {
    uiState: { ...uiState, sellerId },
    actions: { onMoreOptionSelected },
  };
}
